import React, { useState, useEffect } from 'react';
import './LatLongCreation.css';
import Select from 'react-select';
import { getAllDistrictBihar, getDistrict, getStates } from '../../../services/monthlyAttendanceService';
import { getBlocksBasedOnsubId, getsubdivisionsBasedonDid, saveGodownLocation } from '../../../services/godownLatLongService';
import { capitalizeFirstLetter, isAlphabet, isValidAlphanumeric, isValidLatitude, isValidLongitude } from '../../../utils/validations';
import { useNavigate } from 'react-router-dom';

const LatLongCreation = () => {
  const [state, setState] = useState(3);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [districtId, setDistrictId] = useState(null);
  const [subDivisionOptions, setSubDivisionOptions] = useState([]);
  const [subDivisionId, setSubDivisionId] = useState(null);
  const [blockOptions, setBlocksOptions] = useState([]);
  const [blockId, setBlockId] = useState(null);
  const [godownType, setGodownType] = useState(null);
  const [godownId, setGodownId] = useState('');
  const [godownName, setGodownName] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  // const [formData, setFormData] = useState({
  //   godownId: '',
  //   godownName: '',
  //   latitude: '',
  //   longitude: ''
  // });
  const navigate = useNavigate();


  const godownTypeOptions = [
    { value: 'CMR', label: 'CMR' },
    { value: 'TPDS', label: 'TPDS' },

  ];

  // Fetch Districts
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const res = await getStates();
        setStateOptions(res.map(item => ({
          value: item.id,
          label: capitalizeFirstLetter(item.stateName)
        })));
      } catch (err) {
        console.error('Error fetching states:', err);
      }
    };

    fetchStates();
  }, []);

  // Fetch Districts
  useEffect(() => {
    const fetchDistricts = async () => {
      if (state) {
        try {
          const data = await getDistrict(state);
          const formattedOptions = data.map(item => ({
            value: item.districtId,
            label: item.districtName,
          }));
          setDistrictOptions(formattedOptions);
        } catch (err) {
          console.error('Error fetching districts:', err);
        }
      }
    };
    fetchDistricts();
  }, [state]);

  const fecthSubdivision = async (districtId) => {
    if (districtId) {

      try {
        const data = await getsubdivisionsBasedonDid(districtId);
        const formatedSub = data.map(sub => ({
          value: sub.id,
          label: capitalizeFirstLetter(sub.subDivisionName)
        }))
        setSubDivisionOptions(formatedSub);

      } catch (err) {
        console.error('Erro fetching Subdivison', err)
      }
    }

  }

  useEffect(() => {
    fecthSubdivision(districtId);
  }, [districtId])

  const fetchBlocks = async (subDivisionId) => {
    if (subDivisionId) {
      try {
        const data = await getBlocksBasedOnsubId(subDivisionId);
        const formatedBlock = data.map(blo => ({
          value: blo.id,
          label: capitalizeFirstLetter(blo.blockName)
        }))
        setBlocksOptions(formatedBlock);

      }
      catch (error) {
        console.log(error)
      }
    }
  }
  useEffect(() => {
    fetchBlocks(subDivisionId)
  }, [subDivisionId])


  const handleDistrictChange = (selectedOption) => {
    setDistrictId(selectedOption ? selectedOption.value : null);
  };

  const handleSubDivisionChange = (selectedOption) => {
    setSubDivisionId(selectedOption ? selectedOption.value : null);
  };

  const handleBlockChange = (selectedOption) => {
    setBlockId(selectedOption ? selectedOption.value : null);
  };

  const handleGodownTypeChange = (selectedOption) => {
    setGodownType(selectedOption ? selectedOption.value : null);
  };



  const handleReset = () => {
    setDistrictId(null);
    setSubDivisionId(null);
    setBlockId(null);
    setGodownType(null);
    setLatitude("");
    setLongitude('');
    setGodownId("");
    setGodownName('');
  };

  const handleSubmit = async () => {
    if (!blockId || !godownType || !godownId || !godownName || !latitude || !longitude) {
      alert("Please fill all fields");
      return;
    }
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);


    // 2. Range Validation
    if (lat < -90 || lat > 90) {
      alert("Latitude must be between -90 and 90.");
      return;
    }
    if (lng < -180 || lng > 180) {
      alert("Longitude must be between -180 and 180.");
      return;
    }

    // 3. Your specific condition: Longitude is not less than Latitude
    if (lng < lat) {
      alert("Validation Error: Longitude cannot be less than Latitude.");
      return;
    }

    const payload = {
      godownId,
      godownName,
      latitude: parseFloat(lat),
      longitude: parseFloat(lng),
      godownType,
      block: {
        id: blockId
      },
      currentStatus: "ACTIVE"
    };

    try {
      await saveGodownLocation(payload);
      alert("Godown Location saved successfully!");
      handleReset();
    } catch (error) {
      alert("Failed to save location. Please try again.");
      console.error(error);
    }
  };
  const gotoCreationLatLong = () => {
    navigate("/latLongUpdate")
  }
  const handleStateChange = (selectedOption) => {
    setState(selectedOption ? selectedOption.value : null);
    setSubDivisionId("");
    setDistrictId("");
    setBlockId("");
  }
  return (
    <div className="lat-long-container">
      <div className="form-card">
        <h2 className="form-title">Create Godown </h2>
        {/* <div className='navigate-btn'>
          <button type='button' className='godown-btn-navigate' onClick={gotoCreationLatLong}>Back</button>
        </div> */}
        <div className="form-grid">
          {/* Row 1 */}
          <div className="input-group-lat-long">
            <Select
              className={`custom-select ${state ? 'has-value' : ''}`}
              classNamePrefix="select"
              placeholder=" "
              isClearable
              options={stateOptions}
              value={stateOptions.find(opt => opt.value === state) || null}
              onChange={handleStateChange}
            />
            <label> <span className='reqiured'>*</span>State</label>
          </div>
          <div className="input-group-lat-long">
            <Select
              className={`custom-select ${districtId ? 'has-value' : ''}`}
              classNamePrefix="select"
              placeholder=" "
              isClearable
              options={districtOptions}
              value={districtOptions.find(opt => opt.value === districtId) || null}
              onChange={handleDistrictChange}
            />
            <label> <span className='reqiured'>*</span>District</label>
          </div>

          <div className="input-group-lat-long">
            <Select
              className={`custom-select ${subDivisionId ? 'has-value' : ''}`}
              classNamePrefix="select"
              placeholder=" "
              isClearable
              options={subDivisionOptions}
              value={subDivisionOptions.find(opt => opt.value === subDivisionId) || null}
              onChange={handleSubDivisionChange}
            />
            <label> <span className='reqiured'>*</span>Sub Division</label>
          </div>

          {/* Row 2 */}
          <div className="input-group-lat-long">
            <Select
              className={`custom-select ${blockId ? 'has-value' : ''}`}
              classNamePrefix="select"
              placeholder=" "
              isClearable
              options={blockOptions}
              value={blockOptions.find(opt => opt.value === blockId) || null}
              onChange={handleBlockChange}
            />
            <label> <span className='reqiured'>*</span>Block</label>
          </div>

          <div className="input-group-lat-long">
            <Select
              className={`custom-select ${godownType ? 'has-value' : ''}`}
              classNamePrefix="select"
              placeholder=" "
              isClearable
              options={godownTypeOptions}
              value={godownTypeOptions.find(opt => opt.value === godownType) || null}
              onChange={handleGodownTypeChange}
            />
            <label> <span className='reqiured'>*</span>Godown Type</label>
          </div>

          {/* Row 3 */}
          <div className="input-group-lat-long">
            <input
              type="text"
              className="custom-input"
              placeholder=" "
              name="godownId"
              value={godownId}
              onChange={(e) => {
                const val = e.target.value;

                // Use the exported method (setting a 12 character limit as an example)
                if (isValidAlphanumeric(val)) {
                  setGodownId(val);
                }
              }}
            />
            <label> <span className='reqiured'>*</span>Godown ID</label>
          </div>

          <div className="input-group-lat-long">
            <input
              type="text"
              className="custom-input"
              placeholder=" "
              name="godownName"
              value={godownName}
              onChange={(e) => { 
                const value=e.target.value;
                //if(isAlphabet(value))
                setGodownName(value) }}
            />
            <label> <span className='reqiured'>*</span>Godown Name</label>
          </div>

          {/* Row 4 */}
          <div className="input-group-lat-long">
            <input
              type="text"
              className="custom-input"
              placeholder=" "
              name="latitude"
              value={latitude}
              onChange={(e) => {
                const val = e.target.value;
                if (isValidLatitude(val)) {
                  setLatitude(val);
                }
              }}
            />
            <label> <span className='reqiured'>*</span>Latitude</label>
          </div>

          <div className="input-group-lat-long">
            <input
              type="text"
              className="custom-input"
              placeholder=" "
              name="longitude"
              value={longitude}
              onChange={(e) => {
                const val = e.target.value;
                if (isValidLongitude(val)) {
                  setLongitude(val);
                }
              }}
            />
            <label> <span className='reqiured'>*</span>Longitude</label>
          </div>
        </div>

        <div className="button-group-lat">
          <button className="btn btn-primary-lat" onClick={handleSubmit}>Save </button>
          <button className="btn btn-secondary-lat" onClick={handleReset}>Clear</button>
        </div>
      </div>
    </div>
  );
};

export default LatLongCreation;